// src/components/BuySteps/CheckStatusStep.js
import React, { useState, useEffect } from 'react';
import { checkBuyOrder } from '../../services/proptService';

const CheckStatusStep = ({ rateData, setCurrentStep }) => {
    const [statusMessage, setStatusMessage] = useState('Initializing verification...');
    const [error, setError] = useState('');

    useEffect(() => {
        if (!rateData || !rateData.payment_id) {
            setError("Order details are missing. Cannot check status.");
            return;
        }

        // Variable para guardar el ID del intervalo y poder limpiarlo
        let pollingInterval;

        const checkStatus = async () => {
            console.log("Checking order status...");
            try {
                const params = {
                    payment_id: rateData.payment_id,
                    currency: rateData.currency,
                    address: rateData.address,
                };
                console.log("3. CheckBuyOrder -> Enviando Params:", params);
                const data = await checkBuyOrder(params);
                // console.log("Check Status Response:", data);

                const statusText = data.status?.toLowerCase() || ''; // Para comparar de forma segura

                // 1. Revisa si la orden está confirmada (éxito)
                if (data.confirmed === true) {
                    clearInterval(pollingInterval);
                    setCurrentStep(5); // Avanza al paso de ÉXITO

                    // 2. Revisa si la orden ha fallado O ha sido cancelada
                } else if (statusText.includes('failed') || statusText.includes('cancelled')) {
                    clearInterval(pollingInterval);
                    setCurrentStep(6); // Avanza al paso de FALLO (CardStep5)

                } else {
                    // 3. Si no es ninguno de los anteriores, sigue esperando
                    setStatusMessage(data.status || "Waiting for confirmation...");
                }

            } catch (err) {
                console.error("Error during status check:", err);
                setError(err.message || "Failed to check order status.");
                clearInterval(pollingInterval); // Detenemos en caso de error
            }
        };

        // 1. Llama una vez inmediatamente para no esperar 15 segundos la primera vez
        checkStatus();

        // 2. Luego, establece el intervalo para repetir la verificación
        pollingInterval = setInterval(checkStatus, 15000); // Cada 15 segundos

        // 3. Función de limpieza: se ejecuta cuando el componente se desmonta. Es crucial.
        return () => {
            clearInterval(pollingInterval);
        };

    }, [rateData, setCurrentStep]); // El efecto se ejecuta cuando las props cambian

    // El JSX para el renderizado no necesita cambios
    return (
        <div className="modal_content_body text-center">
            <h3 className="ppt_form_title mb-4">Verifying Your Payment</h3>

            {error ? (
                <div>
                    <p className="text-danger">{error}</p>
                    <button onClick={() => setCurrentStep(3)} className="ppt_btn_secondary alt mt-3">Try Again</button>
                </div>
            ) : (
                <div>
                    <div className="spinner-border text-warning mb-3" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mb-2">{statusMessage}</p>
                    <small className="text-muted">This may take a few minutes. Please do not close this window.</small>
                </div>
            )}
        </div>
    );
};

export default CheckStatusStep;